import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "../icon-component.types";

export const IconItalic: TIconComponent = props => (
    <Icon viewBox="0 0 16 16" fill="none" {...props}>
        <path
            d="M1.33337 15.2258H5.33337M5.33337 15.2258L10.6667 0.77417M5.33337 15.2258H10M10.6667 0.77417H6.00004M10.6667 0.77417H14.6667"
            stroke="#333333"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);
